<div class="max-w-2xl mx-auto p-6">
    <!-- Header -->
    <div class="flex items-center justify-between mb-6">
        <div>
            <h1 class="text-2xl font-semibold text-gray-900">Create New Customer</h1>
            <p class="text-sm text-gray-600 mt-1">Create a new customer. Four operator groups (Admin, SuperUser, Member,
                Owner)
                will be created automatically.</p>
        </div>
        <button type="button" (click)="onCancel()"
            class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            Cancel
        </button>
    </div>

    <!-- Success Message -->
    @if (successMessage) {
    <div class="mb-6">
        <jjames-alert type="success" [dismissible]="true" (dismissed)="onClearSuccess()">
            {{ successMessage }}
        </jjames-alert>
    </div>
    }

    <!-- Error Message -->
    @if (errorMessage) {
    <div class="mb-6">
        <jjames-alert type="error" [dismissible]="true" (dismissed)="onClearError()">
            {{ errorMessage }}
        </jjames-alert>
    </div>
    }

    <!-- Form -->
    <jjames-card>
        <form [formGroup]="createCustomerForm" (ngSubmit)="onSubmit()" class="space-y-6">
            <!-- Customer Name -->
            <div>
                <jjames-input inputId="name" label="Customer Name" type="text" formControlName="name" [required]="true"
                    [variant]="isFieldInvalid('name') ? 'error' : 'default'" [errorMessage]="getFieldError('name')"
                    placeholder="Enter customer name (e.g., Hainzl GmbH)">
                </jjames-input>
            </div>

            <!-- Info Box -->
            <div class="bg-blue-50 border-l-4 border-blue-400 p-4">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <svg class="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="ml-3">
                        <p class="text-sm text-blue-700">
                            <strong>Note:</strong> When you create a customer, the system will automatically create four
                            operator groups:
                        </p>
                        <ul class="mt-2 text-sm text-blue-700 list-disc list-inside space-y-1">
                            <li><strong>Owner Group</strong> - For customer owners</li>
                            <li><strong>Admin Group</strong> - For administrative operators</li>
                            <li><strong>SuperUser Group</strong> - For super user operators</li>
                            <li><strong>Member Group</strong> - For regular member operators</li>
                            <li><strong>Viewer Group</strong> - For view-only operators</li>
                        </ul>
                        <p class="mt-2 text-sm text-blue-700">
                            After creating the customer, you can create the first operator admin and assign them to one
                            of these groups.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="flex items-center justify-end space-x-4 pt-6 border-t border-gray-200">
                <jjames-button type="button" variant="secondary" (clicked)="onCancel()" [disabled]="isSubmitting">
                    Cancel
                </jjames-button>
                <jjames-button type="submit" variant="primary" [disabled]="isSubmitting || createCustomerForm.invalid"
                    iconLeft="fas fa-save">
                    @if (isSubmitting) {
                    Creating...
                    } @else {
                    Create Customer
                    }
                </jjames-button>
            </div>
        </form>
    </jjames-card>
</div>